// Construction and Infrastructure inner page — Industries tile 04.
import { ArrowRight } from "lucide-react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import InnerHero from "../../components/InnerHero";
import Reveal from "../../components/Reveal";
import { VIDEOS } from "../../lib/media";

export default function Construction() {
  return (
    <div className="bg-black">
      <Nav route="inner" />
      <InnerHero
        video={VIDEOS.construction}
        eyebrow="Industries · Construction and Infrastructure"
        headline="AI for the builders who"
        italicWord="deliver."
        lede="We build AI tools that help construction and infrastructure businesses move faster, stay compliant and give clients the transparency they expect."
      />

      <section className="bg-black py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6">

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">What we build</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Site copilots, compliance tools and supply-chain visibility.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              AI site copilots that help project managers track progress, surface risks and generate
              compliance evidence without manual data entry. Subcontractor management tools that give
              primes real-time visibility into the supply chain.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              Automated reporting for safety, environmental and quality obligations. Computer vision
              for site progress monitoring and defect detection on large infrastructure projects.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">How we work with construction clients</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              We fit into your project cadence.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              Construction projects move fast and do not have time for slow technology implementations.
              We design for rapid deployment. Most site tools are live within four weeks.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              We work with your existing project management and document control systems. We add AI
              capability without requiring your team to change the tools they use every day.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">Right for you if</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              You are a tier-one builder or infrastructure deliverer.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              You have reporting and compliance obligations that consume significant team time. You want
              to give your client or your government principal better visibility into project progress
              without creating a parallel reporting workstream.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              You want AI tools that work on site, in low-connectivity environments, and produce outputs
              that hold up under scrutiny from auditors and project principals.
            </p>
          </Reveal>

        </div>
      </section>

      <section className="bg-black px-6 pb-24">
        <div className="max-w-2xl mx-auto liquid-glass rounded-3xl p-10 text-center">
          <h3 className="font-instrument text-3xl text-white">Ready to build something that lasts?</h3>
          <p className="text-white/60 text-base mt-4">
            Start with a 30-minute discovery call. No slide deck. Just an engineer.
          </p>
          <a
            href="/#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-8 py-3 bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors"
          >
            Book a discovery <ArrowRight size={16} />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
